import {
  HardHat, Sprout, Truck, Anchor, Factory, Cpu, Zap, Mountain,
  TreePine, Flame, Hammer, UtensilsCrossed, FlaskConical,
  Fuel, Waves, Droplets, Ship,
} from "lucide-react";
import { MARKETS } from "@/lib/brand";

const ICONS = {
  "Construção": HardHat,
  "Agronegócio": Sprout,
  "Logística": Truck,
  "Portos": Anchor,
  "Indústria": Factory,
  "Automação": Cpu,
  "Energia": Zap,
  "Mineração": Mountain,
  "Papel e Celulose": TreePine,
  "Siderurgia": Flame,
  "Metalurgia": Hammer,
  "Alimentos": UtensilsCrossed,
  "Química": FlaskConical,
  "Petróleo e Gás": Fuel,
  "Área Offshore": Waves,
  "Refinarias": Droplets,
  "Estaleiros": Ship,
  "Indústria Naval": Ship,
};

const IMG =
  "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?auto=format&fit=crop&w=1600&q=80";

export const Markets = () => {
  return (
    <section
      id="mercados"
      data-testid="markets-section"
      className="relative py-24 lg:py-32 bg-navy text-white overflow-hidden grain"
    >
      <div
        className="absolute inset-0 opacity-[0.14]"
        style={{
          backgroundImage: `url(${IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-b from-navy via-navy/95 to-navy" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Mercados Atendidos</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="markets-title"
            >
              Onde a operação não pode parar,
              <br />
              a gente está.
            </h2>
          </div>
          <p className="max-w-md text-lg text-white/70 leading-relaxed reveal">
            Atendemos setores estratégicos da economia brasileira, com curadoria técnica
            específica para cada realidade operacional.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {MARKETS.map((m, i) => {
            const Icon = ICONS[m] || Factory;
            return (
              <div
                key={m}
                className="reveal group relative rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:bg-white/[0.08] hover:border-gold/40 transition-colors backdrop-blur-sm"
                data-testid={`market-card-${i}`}
                style={{ transitionDelay: `${i * 40}ms` }}
              >
                <div className="w-11 h-11 rounded-lg bg-white/10 border border-white/10 flex items-center justify-center mb-5 group-hover:bg-gold group-hover:border-gold transition-colors">
                  <Icon className="w-5 h-5 text-white" />
                </div>
                <div className="font-display font-semibold text-lg leading-snug">{m}</div>
                <div className="mt-3 text-xs text-white/40 group-hover:text-white/80 transition-colors">
                  Ver segmento →
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
